import Menu from './components/menus'
import HeaderScroll from './components/HeaderScroll'
import SmoothScroll from './utils/SmoothScroll'
import ValueSlider from './components/ValueSlider'
import ImageSlider from './components/ImageSlider'
import CompanyMenu from './components/CompanyMenu'
import TextAnimations from './components/TextAnimations'
import Footer from './components/Footer'
import Map from './components/Map'
import DarkTeaseHover from './utils/dark-tease-hover'
import GallerySlider from './components/GallerySlider'
import CompanyStackCards from './components/CompanyStackCards'
import ParallaxImages from './components/ParallaxImages'
import HomeBanner from './components/HomeBanner'
import HomeIntro from './components/HomeIntro'
import TextBlockAnimation from './components/TextBlockAnimation'
import ExpandTopThree from './utils/expand-top-three'
import GreyscaleSliderHover from './utils/greyscale-slider-hover'

document.addEventListener('DOMContentLoaded', () => {
	new HomeIntro()
	new SmoothScroll()
	new HomeBanner()
	new TextBlockAnimation()
	new Menu()
	new CompanyStackCards()
	new ParallaxImages()
	new TextAnimations()
	new ValueSlider()
	new ImageSlider()
	new GallerySlider()
	new Map()
	new CompanyMenu()
	new HeaderScroll()
	new Footer()
	new DarkTeaseHover()
	new GreyscaleSliderHover()
	new ExpandTopThree()
})
